<template>
  <form-box
    title="客户信息"
    :button-text="type === 'check' ? '' : '增加客户'"
    @add="addCustomInfo"
  >
    <template v-if="customInfoInfoFormArr && customInfoInfoFormArr.length">
      <div
        v-for="(item, index) in customInfoInfoFormArr"
        :key="index"
        class="form-content"
      >
        <el-form
          :ref="`customInfoForm${index}`"
          class="form-box"
          size="medium"
          label-position="top"
          :rules="rules"
          :model="item"
        >
          <div class="delete-btn" v-if="type !== 'check'">
            <span @click="deleteCustomInfo(index)"
              ><i class="el-icon-delete"></i>删除</span
            >
          </div>
          <div class="form-row">
            <!-- 左侧表单 -->
            <div class="form-column">
              <el-form-item label="年份" prop="year">
                <el-date-picker
                  v-model="item.year"
                  :disabled="type === 'check'"
                  type="year"
                  format="yyyy 年"
                  value-format="yyyy"
                  placeholder="选择年"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="客户姓名">
                <el-input
                  v-model="item.customerName"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="20"
                  placeholder="请输入客户姓名"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="下游客户类型" prop="fromCustomerType">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.fromCustomerType"
                  placeholder="请选择下游客户类型"
                >
                  <el-option
                    v-for="item in allSelectData.fromCustomerTypeArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售方式" prop="saleType">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.saleType"
                  placeholder="请选择销售方式"
                >
                  <el-option
                    v-for="item in allSelectData.saleTypeArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- 右侧表单 -->
            <div class="form-column">
              <el-form-item label="上游客户类型" prop="toCustomerType">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.toCustomerType"
                  placeholder="请选择上游客户类型"
                >
                  <el-option
                    v-for="item in allSelectData.toCustomerTypeArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年度合同金额" prop="contractAmount">
                <el-input
                  v-model="item.contractAmount"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="10"
                  placeholder="请输入年度合同金额"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="合作期限" prop="deadline">
                <el-input
                  v-model="item.deadline"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="2"
                  placeholder="请输入合作期限"
                >
                  <template slot="append">年</template>
                </el-input>
              </el-form-item>
              <el-form-item label="合同年度金额" prop="yearContractAmount">
                <el-input
                  v-model="item.yearContractAmount"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="10"
                  placeholder="请输入合同年度金额"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <Empty v-else emptyTxt="暂无客户信息"></Empty>
  </form-box>
</template>

<script>
import FormBox from "./FormBox.vue";
import Empty from "./Empty.vue";
export default {
  name: "CustomInfo",
  components: {
    FormBox,
    Empty,
  },
  props: {
    customInfoInfoFormArr: {
      type: Array,
      default() {
        return [];
      },
    },
    allSelectData: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    const validateNumAndEmpty = (rule, value, callback) => {
      const pattern = /^\d{0,10}(\.\d{0,2})?$/g;
      if (value && !pattern.test(value)) {
        callback(
          new Error(`${rule.message}必须为数字（整数或保留两位小数）或者空`)
        );
      }
      callback();
    };
    const validateInteger = (rule, value, callback) => {
      if (value && !/^[1-9]\d*$/.test(value)) {
        return callback(new Error("请输入正整数"));
      }
      return callback();
    };
    return {
      rules: {
        deadline: [
          {
            trigger: "blur",
            validator: validateInteger,
          },
        ],
        contractAmount: [
          {
            trigger: "blur",
            message: "年度合同金额必须为数字（整数或保留两位小数）",
            validator: validateNumAndEmpty,
          },
        ],
        yearContractAmount: [
          {
            trigger: "blur",
            message: "合同年度金额必须为数字（整数或保留两位小数）",
            validator: validateNumAndEmpty,
          },
        ],
      },
    };
  },
  methods: {
    addCustomInfo() {
      this.$emit("add", "customerInfoDTOList");
    },
    deleteCustomInfo(index) {
      this.$emit("delete", "customerInfoDTOList", index);
    },
  },
};
</script>

<style scoped lang="scss">
.form-content {
  background: #f7f9fb;
  margin-bottom: 20px;
  .form-box {
    .delete-btn {
      text-align: right;
      font-size: 14px;
      color: #ff5c5c;
      padding: 18px 16px 0 0;
      span {
        cursor: pointer;
      }
      i {
        font-size: 18px;
        margin-right: 4px;
      }
    }
    .form-row {
      display: flex;

      .form-column {
        padding: 40px 0 30px 100px;
        flex: 1;
        ::v-deep .el-form-item__label {
          line-height: normal !important;
        }
        .ipt,
        .el-select,
        .el-date-editor {
          width: 374px;
        }
      }
    }
  }
}
</style>
